import { isArray, isEmpty } from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { PermissionsEnum } from 'src/containers/include/Permission';
import { useUserPermContext } from 'src/containers/include/UserPermContext';

export interface IPermissionValue {
    permission?: React.Key | React.Key[];
    [x: string]: any;
}

export const usePermission = () => {

    const permMap = useUserPermContext();

    const findPermission = useCallback(<T extends React.Key>(permission: T[] | T): boolean => {
        if (isArray(permission)) {
            return permission.every(p => !!permMap[p]);
        }
        return !!permMap[permission];
    }, [permMap]);

    const filterPermission = useCallback(<T extends IPermissionValue>(target: T[] = []): T[] => {
        if (isEmpty(Object.keys(permMap))) return target;

        return target.reduce((pre: T[], cur: T) => {
            if (cur.permission == null || findPermission(cur.permission)) {
                pre.push(cur);
            }
            return pre;
        }, []);
    }, [permMap]);

    return {
        permMap,
        findPermission,
        filterPermission
    };
};

/**
 * 页面权限判断
 * @param permission 
 */
export const usePermissionPage = (permission: PermissionsEnum | PermissionsEnum[]) => {
    const permMap = useUserPermContext();
    const history = useHistory();

    useEffect(() => {
        if (isArray(permission) ? permission.some(item => !permMap[item]) : !permMap[permission]) {
            history.replace('/403');
        }
    }, []);

    return { permMap, history };
};